<template>
  <v-app>
    <v-main class="auth-pages">
      <fade-transition :duration="200" origin="center top" mode="out-in">
        <!-- your content here -->
        <v-container class="mt-n16 pb-0">
          <router-view></router-view>
        </v-container>
      </fade-transition>
    </v-main>
  </v-app>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  name: "page-layout",
  components: {
    FadeTransition,
  },
  data() {
    return {
      paragraphs: "",
      tab: null,
      phrases: [
        "Initializing BCI device...",
        "Syncing brainwave channels...",
        "Analyzing mental state...",
        "Ready to begin.",
      ],
      currentPhraseIndex: 0,
      currentPhrase: "Initializing BCI device...",
    };
  },
  mounted() {
    this.startPhraseRotation();
  },
  methods: {
    startPhraseRotation() {
      this.interval = setInterval(() => {
        if (this.currentPhraseIndex < this.phrases.length - 1) {
          this.currentPhraseIndex++;
          this.currentPhrase = this.phrases[this.currentPhraseIndex];
        } else {
          clearInterval(this.interval);
          // Wait 1 second before redirecting
          setTimeout(() => {
            // this.$router.push("/mood");
          }, 1000);
        }
      }, 2000);
    },
  },
  beforeDestroy() {
    // Clean up the interval to prevent memory leaks
    clearInterval(this.interval);
  },
};
</script>
